import { Component, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';

@Component({
	selector: 'app-lift-stats',
	styleUrls: ['./lift-stats.component.css'],
	templateUrl: './lift-stats.component.html'
})
export class LiftStatsComponent implements OnInit, WidgetCore, OnDestroy {
	public key: string;
	public sectiontitle: string;
	public sectionclass: string;
	public version: string;
	public directoryName: string;

	liftStatsData: any;
	hasLiftData = true;
	public showLoad = true;
	public hasData = true;
	public reloadSubscription;
	public widgetDataSubscription;
	protected isR6Enabled: boolean = false;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.version = this.analyticsDataModel.config.version.toLowerCase();
		this.directoryName = this.analyticsDataModel.config.directoryName;
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			if (res.success && res.data.length > 0 && this.verifyCampaignStatus(res.data)) {
				this.hasData = true;
				this.processResponseData(res.data);
			} else {
				this.hasData = false;
				this.hasLiftData = false;
			}
		});
	}

	processResponseData(response: any): void {
		// tslint:disable-next-line: no-parameter-reassignment
		response = response[0];
		if (
			response.average_lift != null ||
			response.average_conversion_rate != null ||
			response.average_baseline != null
		) {
			this.liftStatsData = {
				baseLineRate: UtilityService.isUndefinedOrNull(response.average_baseline)
					? '<0.01'
					: parseFloat(response.average_baseline).toFixed(2),
				digitalLift: parseFloat(response.average_lift) > 100 ? '>99' : response.average_lift,
				exposedRate: parseFloat(response.average_conversion_rate).toFixed(2)
			};
			this.hasLiftData = true;
		} else {
			this.hasLiftData = false;
		}
	}

	verifyCampaignStatus(campaignList: any[]): boolean {
		let status = false;
		if (this.isR6Enabled) {
			status = campaignList.reduce((acc, value, i) => {
				return acc || UtilityService.toTrueOrFalse(value['show_lift_data']);
			}, status);
		} else {
			status = true;
		}
		return status;
	}
}
